define('collection/TimeGridCollection',['require','lib/collection/TimeGroupCollection','Config'],function (require) {

    var BaseCollection = require('lib/collection/TimeGroupCollection');
    var Config = require('Config');

    /**
     * Time Grid collection
     *
     * @class TimeGridCollection
     */
    return BaseCollection.extend({

        url: '/booking/timegrid/',
        // model: //TODO timeslot with service/provider/etc included

    }, {
        
        filterByTime: function (collection, timeDiff, activeTimeOfDay) {
            var _this = this;
            return collection.any(function (model) {
                return _this.matchesTime(model, timeDiff, activeTimeOfDay);
            });
        },
        
        matchesTime: function (model, timeDiff, activeTimeOfDay) {
            var time = new Time(model.get('time'));
            var intTime = time.getInteger();
                
            // using client time zone
            var clientTime = intTime + timeDiff;
            
            // normalize
            while (clientTime < 0) clientTime += 24*60;
            while (clientTime >= 24*60) clientTime -= 24*60;
            
            switch (activeTimeOfDay) {
                case 'morning': 
                    return clientTime < new Time('12:00').getInteger(); 
                    
                case 'afternoon': 
                    return clientTime >= new Time('12:00').getInteger() && clientTime < new Time('18:00').getInteger(); 
                    
                case 'evening': 
                    return clientTime >= new Time('18:00').getInteger(); 
                    
            }
            
            return true;
        }
        
    });

});
